type Props = {
  lat: number;
  lng: number;
}

export function calculateDistance(from: Props, to: Props) {
  const dLat = (from.lat - to.lat) * Math.PI / 180;
  const dLng = (from.lng - to.lng) * Math.PI / 180;

  const cosResult = 0.5 - Math.cos(dLat) / 2 
      + Math.cos(to.lat * Math.PI / 180) * Math.cos(from.lat * Math.PI / 180)
      * (1 - Math.cos(dLng)) / 2;
  
  return Math.round(6371000 * 2 * Math.asin(Math.sqrt(cosResult)));
}